import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { web3WalletSupportLinks } from '~/data/web3WalletSupportLinks';
import { IProviderOption } from '~/store/web3_wallet/types';
import ReplaceGalaWalletStep1 from './ReplaceGalaWalletStep1.vue';
import ReplaceGalaWalletStep2 from './ReplaceGalaWalletStep2.vue';
import ReplaceGalaWalletStep3 from './ReplaceGalaWalletStep3.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReplaceGalaWalletStepper',
  props: {
    providerOptions: null,
    selectedProvider: null
  },
  emits: ["connect"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'connect', option: IProviderOption): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  providerOptions: IProviderOption[];
  selectedProvider: IProviderOption | null;
};





const step = ref(1);
const steps = computed(() => [
  {
    title: 'Recovery Phrase',
    component: ReplaceGalaWalletStep1,
  },
  {
    title: 'Import',
    component: ReplaceGalaWalletStep2,
  },
  {
    title: 'Connect',
    component: ReplaceGalaWalletStep3,
    props: {
      providerOptions: props.providerOptions,
      selectedProvider: props.selectedProvider,
    },
    on: {
      connect: (option: IProviderOption) => {
        emit('connect', option);
      },
    },
  },
]);

const handleContinue = () => {
  if (step.value < steps.value.length) {
    step.value += 1;
  }
};

const handleBack = () => {
  if (step.value > 1) {
    step.value -= 1;
  }
};

return { __sfc: true,props, emit, step, steps, handleContinue, handleBack, web3WalletSupportLinks }
}

})